import Typography from '@/components/atoms/typography/typography';
import MediaGrid from '@/components/organisms/media-grid/media-grid';
import Container from '@/components/utilities/container/container';
import ModuleWrapper, {
  ModuleWrapperProps,
} from '@/components/utilities/module-wrapper/module-wrapper';
import styles from './image-and-video-grid.module.scss';

export interface ImageAndVideoGridProps extends ModuleWrapperProps {
  /** The headline of the grid. */
  headline: Content.Components['ImageAndVideoGridModuleDto']['headline'];
  /** The items to display in the grid. */
  items: Content.Components['ImageAndVideoGridModuleDto']['items'];
}

const ImageAndVideoGrid = ({
  headline,
  items,
  ...rest
}: ImageAndVideoGridProps) => {
  return (
    <ModuleWrapper {...rest} className={styles.component}>
      <Container>
        <Typography className={styles.title} tag="h2" tagStyle="displayMedium">
          {headline}
        </Typography>

        <MediaGrid items={items} />
      </Container>
    </ModuleWrapper>
  );
};

ImageAndVideoGrid.displayName = 'ImageAndVideoGrid';

export default ImageAndVideoGrid;
